// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6rm9A","select":"styles_select__2Q6PQ"};